import React, { forwardRef } from 'react'
import {
  EButtonType,
  IButtonBaseProps,
  IButtonProps,
  ITertiaryButtonProps,
} from './Button.types'
import css from './Button.module.scss'

const Loading = () => (
  <img
    className={css.spinner}
    src="https://cdn.nextretreat.com//gif/spinner-loading-indicator.gif"
    alt="loading indicator"
  />
)

const ButtonBase = forwardRef<HTMLButtonElement, IButtonBaseProps>(
  (
    {
      children,
      disabled,
      href,
      iconLeft,
      iconRight,
      viewType = EButtonType.CONTAINER,
      isBlock,
      element = 'button',
      className,
      fillSvg,
      isLoading,
      ...passingProps
    },
    ref
  ) => {
    const Element = element

    const content = (
      <>
        {isLoading ? <Loading /> : iconLeft}
        {typeof children === 'string' ? (
          <div className={css.flex}>{children}</div>
        ) : (
          children
        )}
        {iconRight}
      </>
    )

    return (
      // @ts-ignore
      <Element
        className={`${css.styledButtonBase} ${
          viewType === EButtonType.CONTAINER ? css.container : css.plain
        } ${isBlock ? css.isBlock : ''} ${disabled ? css.disabled : ''}  ${
          fillSvg ? css.fillSvg : ''
        } ${className}`}
        disabled={disabled || isLoading}
        href={!disabled || isLoading ? href : undefined}
        {...passingProps}
        ref={ref as any}
      >
        {element === 'button' ? (
          // @ts-ignore
          <div className={css.flex}>{content}</div>
        ) : (
          content
        )}
      </Element>
    )
  }
)

export const PrimaryButton = forwardRef<HTMLButtonElement, IButtonProps>(
  ({ className, ...passingProps }, ref) => (
    <ButtonBase
      className={`${css.primary} ${className}`}
      ref={ref}
      {...passingProps}
    />
  )
)

export const DarkButton = forwardRef<HTMLButtonElement, IButtonProps>(
  ({ className, ...passingProps }, ref) => (
    <ButtonBase
      className={`${css.dark} ${className}`}
      ref={ref}
      {...passingProps}
    />
  )
)

export const SecondaryButton = forwardRef<HTMLButtonElement, IButtonProps>(
  ({ className, ...passingProps }, ref) => (
    <ButtonBase
      className={`${css.secondary} ${className}`}
      ref={ref}
      {...passingProps}
    />
  )
)

export const TertiaryButton = forwardRef<
  HTMLButtonElement,
  ITertiaryButtonProps
>(({ className, ...passingProps }, ref) => (
  <ButtonBase
    className={`${css.tertiary} ${className}`}
    ref={ref}
    {...passingProps}
  />
))

export const NegativeButton = forwardRef<HTMLButtonElement, IButtonProps>(
  ({ className, ...passingProps }, ref) => (
    <ButtonBase
      className={`${css.negative} ${className}`}
      ref={ref}
      {...passingProps}
    />
  )
)
